import type { ReactElement, Ref } from 'react';
import { forwardRef, Fragment } from 'react';

import { Skeleton, Typography } from '..';

import type { TBoxProps, TLoaderObjectType } from './box.interface';
import { PodSkeleton } from './components';

export const Box = forwardRef(
  (
    {
      title,
      children,
      loading = false,
      direction = 'row',
      repeat = 1,
      variant = 'none',
      spacing = 8,
      height = null,
      cursorPointer = false
    }: TBoxProps,
    ref: Ref<HTMLDivElement>
  ): ReactElement => {
    const SkeletonLoader: Partial<TLoaderObjectType> = {
      pod: <PodSkeleton />,
      none: <Skeleton variant="rectangular" />
    };
    return (
      <div
        ref={ref}
        className={`
                co-flex
                co-flex-wrap
                co-gap-${spacing}px
                co-flex-shrink-0
                co-w-full
                ${direction === 'row' ? 'co-flex-row' : ''}
                ${height ? height : ''}
                ${cursorPointer ? 'co-cursor-pointer' : ''}
                `}
      >
        {title &&
          (loading ? (
            <div className="co-flex-0 co-min-h-24px co-items-center co-flex co-w-1/2">
              <Skeleton variant="rectangular" />
            </div>
          ) : (
            title !== 'skeleton-only' && (
              <div className="co-flex-0 co-w-full co-items-center co-flex">
                <Typography weight="semibold" size="h4">
                  {title}
                </Typography>
              </div>
            )
          ))}

        {loading ? (
          <div
            className={`co-flex-0 co-w-full co-min-h-40px co-gap-${spacing}px co-flex co-flex-${direction}`}
          >
            {[...Array(repeat)].fill(null).map((_, i) => (
              <Fragment key={i}>{SkeletonLoader[variant]}</Fragment>
            ))}
          </div>
        ) : (
          children
        )}
      </div>
    );
  }
);
